import {useTranslation} from 'react-i18next'
import {ConfirmDialog} from '@/components/confirm-dialog'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {MapaTeclas} from '@/components/bateria/cola/mapa-teclas'
import type {SeccionClave} from '@/lib/bateria-cola'

export function DialogosDeLaCola({
  salidaConPendientes,
  porSincronizar,
  onSalidaOpenChange,
  onSalir,
  mapaAbierto,
  onMapaOpenChange,
  seccion,
}: {
  salidaConPendientes: boolean
  porSincronizar: number
  onSalidaOpenChange: (abierto: boolean) => void
  /** Salir no abandona lo pendiente: el desmontaje lo manda. */
  onSalir: () => void
  mapaAbierto: boolean
  onMapaOpenChange: (abierto: boolean) => void
  seccion: SeccionClave | null
}) {
  const {t} = useTranslation()
  return (
    <>
      <ConfirmDialog
        open={salidaConPendientes}
        onOpenChange={onSalidaOpenChange}
        title={t('admin.bateria.cola.salida.titulo', {count: porSincronizar})}
        description={t('admin.bateria.cola.salida.cuerpo')}
        confirmLabel={t('admin.bateria.cola.salida.salir')}
        cancelLabel={t('admin.bateria.cola.salida.quedarse')}
        onConfirm={onSalir}
      />

      <Dialog open={mapaAbierto} onOpenChange={onMapaOpenChange}>
        <DialogContent data-testid="cola-mapa-dialogo">
          <DialogHeader>
            <DialogTitle>{t('admin.bateria.cola.mapa.titulo')}</DialogTitle>
          </DialogHeader>
          <MapaTeclas seccion={seccion ?? 'marcas_5'} />
        </DialogContent>
      </Dialog>
    </>
  )
}
